import { action } from 'mobx';
import { LinksService } from 'common/data';
import { BaseStore } from 'core/stores';

class LinksStore extends BaseStore {
	constructor(rootStore) {
		super(new LinksService(rootStore.app.baasic.apiClient));
	}

	@action
	findLinks = async filter => {
		const response = await this.service.findLinks(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
	};

	@action
	createLink = async resource => {
		return await this.service.createLink(resource);
	};

	@action
	updateLink = async resource => {
		return await this.service.updateLink(resource);
	};

	@action
	deleteLink = async id => {
		return await this.service.deleteLink(id);
	};
}

export default LinksStore;
